<template>
  <div class="login-wrap" ref="editorDOM">
    <div class="temp-box">
    <img class="img" src="../images/bg.jpg" alt="">
    <div class="login-form">
      <div class="bg-box"></div>
      <div class="real-box">
        <h2>用户注册</h2>
        <div class="usually-box user-wrap">
          <label>手机号码</label>
          <input v-model="username" type="text" placeholder="请输入手机号码">
        </div>
        <div class="usually-box password-wrap">
          <label>输入密码</label>
          <input v-model="password" type="password" maxlength="20" placeholder="8-20位字母、数字、特殊字符结合">
        </div>
        <div class="usually-box two-password-wrap">
          <label>再次输入密码</label>
          <input v-model="twoPassword" type="password" maxlength="20" placeholder="8-20位字母、数字、特殊字符结合">
        </div>
        <div class="usually-box yz-wrap">
          <label>图片验证码</label>
          <input v-model="picYzm" type="text" placeholder="请输入图片验证码">
          <canvas @click="drawCanvas" id="yzm"></canvas>
        </div>
        <div class="usually-box yzt-wrap">
          <label>验证码</label>
          <input v-model="yzm" type="text" placeholder="请输入短信验证码">
          <span @click="getYzm" class="get-yzm">{{yzmTxt}}</span>
        </div>
        <div class="login-btn" @click="sendPost">
          <img src="../images/login-img2.png" alt=""><span>注册</span> 
        </div>
        <div class="txt">
          <a @click="goLogin">已有账号，立即登录</a>
        </div>
      </div>
    </div>
    </div>
  </div>
</template>

<script>
import { JSEncrypt } from 'jsencrypt';
import { getLLPosition, isComplexityMatches, checkPhoneNo } from '@/utils/index'

export default {
  name: "register-001",
  data() {
    return Object.assign(
      {
        username: "",
        password: '',
        twoPassword: '',
        picYzm: "",
        yzm: "",
        selfPicYzm: "",
        publicKey: "",
        yzmTxt: "获取验证码",       // 获取验证码内容
        yzmNum: 120,               // 验证码倒计时
        yzmTimer: null,            // 验证码计时器
        longitude: '',
        latitude:'',
      }
    );
  },
  created() {
    this.getPublicKey();
    getLLPosition((lnt,lat)=>{
      // alert(lnt,lat)
      this.longitude = lnt;
      this.latitude = lat;
      localStorage.setItem('longitude', this.longitude);
      localStorage.setItem('latitude', this.latitude);
    });
  },
  mounted() {
    this.drawCanvas();
  },
  methods: {
    // 获取公匙
    getPublicKey() {
      this.$API.rsaPublic().then(res => {
        if(res.code == 0) {
          this.publicKey = res.data;
        }else {
          this.$message.error(res.msg);
        }
      });
    },
    // 加密
    setEncrypt(msg) {
      let jsencrypt = new JSEncrypt({});
      jsencrypt.setPublicKey(this.publicKey);
      return jsencrypt.encrypt(msg);
    },
    // 获取验证码
    getYzm() {
      if(!this.username) {
        this.$message.warning("请输入手机号");
        return
      }
      if(!checkPhoneNo(this.username)) {
        this.$message.warning('请输入正确的手机号');
        return
      }
      if(!this.picYzm) {
        this.$message.warning("请输入图片验证码");
        return
      }
      if(this.picYzm != this.selfPicYzm) {
        this.$message.warning("图片验证码错误");
        this.drawCanvas();
        return
      }
      if(this.yzmTxt != '获取验证码') {
        return
      }
      this.yzmTimer = setInterval(() => {
        this.yzmTxt = this.yzmNum + 's';
        this.yzmNum--;
        if(this.yzmNum <= 0) {
          this.yzmNum = 120;
          this.yzmTxt = '获取验证码';
          clearInterval(this.yzmTimer);
        }
      }, 1000);
      // let obj = {
      //   phone: this.username,
      //   language: 'zh',
      //   purpose: 'R',
      //   sys: 'ohealth',
      //   templateNo: "h05-website",
      //   hospitalCode:"H05"
      // }
      let phone = this.setEncrypt(this.username);
      let language = this.setEncrypt('zh');
      let purpose = this.setEncrypt('R');
      let sys = this.setEncrypt(this.HOSPITAL.sys);
      let templateNo = this.setEncrypt(this.HOSPITAL.templateNo);
      let hospitalCode = this.setEncrypt(this.HOSPITAL.code);
      let obj = {
        phone: phone,
        language: language,
        purpose: purpose,
        sys: sys,
        templateNo: templateNo,
        hospitalCode: hospitalCode,
      }
      this.$API.sendCode(obj).then(res => {
        if(res.code == 0) {
          this.$message.success("获取验证码成功！");
        }else {
          this.$message.error(res.msg);
          this.yzmNum = 120;
          this.yzmTxt = '获取验证码';
          clearInterval(this.yzmTimer);
        }
      }).catch(err => {
        this.yzmNum = 120;
        this.yzmTxt = '获取验证码';
        clearInterval(this.yzmTimer);
      });
    },
    // 发送请求
    sendPost() {
      if(!this.username) {
        this.$message.warning("请输入手机号");
        return
      }
      if(!checkPhoneNo(this.username)) {
        this.$message.warning('请输入正确的手机号');
        return
      }
      if(!this.password) {
        this.$message.warning("请输入密码");
        return
      }
      let reg = /^\S{8,20}$/;
      if(!reg.test(this.password)) {
        return this.$message.warning("密码长度限制在8~20位");
      }
      if(!isComplexityMatches(this.password)) {
        return this.$message.warning("密码必须包含大写字母、小写字母、数字、特殊字符至少三种");
      }
      if(!this.twoPassword) {
        this.$message.warning("请再次输入密码");
        return
      }
      if(this.password !== this.twoPassword) {
        this.$message.warning("两次输入密码不一致");
        return
      }
      if(!this.picYzm) {
        this.$message.warning("请输入图片验证码");
        return
      }
      if(this.picYzm != this.selfPicYzm) {
        this.$message.warning("图片验证码错误");
        this.drawCanvas();
        return
      }
      if(!this.yzm) {
        this.$message.warning("请输入短信验证码");
        return
      }
      // this.password = this.setEncrypt(this.password);
      let password = this.setEncrypt(this.password);
      let obj = {
        phone: this.username,
        pc: password,
        code: this.yzm,
        sys: 'ohealth',
        encryptMode: 'RSA',
        hospitalCode:"H05"
      }
      this.$API.userRegister(obj).then(res => {
        if(res.code == 0) {
          this.$message.success('注册成功！');
          this.goLogin();
        }else {
          this.$message.error(res.msg);
          this.drawCanvas();
        }
      },
      error => {
          this.drawCanvas();
      });
    },
    // 绘制canvas
    drawCanvas() {
      this.selfPicYzm = 0;
      let selfNumList = [];
      let canvas = document.getElementById("yzm"); //获取到canvas对象
      let context = canvas.getContext("2d"); //获取到canvas绘图环境
      //设置画布大小
      canvas.width = 110;
      canvas.height = 50;
      context.strokeRect(0,0,110,50);
      let aCode = [0,1,2,3,4,5,6,7,8,9];
      // 绘制随机数
      for(var i = 0; i < 4; i ++){
        var deg = Math.random() * 30 * Math.PI / 180;
        var x = 20 + i * 20;
        var y = 20 + Math.random() * 10;
        var index = Math.floor(Math.random()*aCode.length); //获取到一个随机的索引值
        var txt = aCode[index]; //获取到数组里面的随机的内容
        selfNumList.push(txt);
        context.font = "bold 20px 微软雅黑"; //设置文字样式
        context.fillStyle = this.getColor();
        context.translate(x,y);
        context.rotate(deg);
        context.fillText(txt,0,0);
        context.rotate(-deg);
        context.translate(-x,-y);
      }
      this.selfPicYzm = selfNumList.join('');
      //绘制干扰线
      for(var i = 0; i < 2; i ++ ){
        context.strokeStyle = this.getColor();
        context.beginPath();
        context.moveTo(Math.random()*120,Math.random()*40);
        context.lineTo(Math.random()*120,Math.random()*40);
        context.stroke();
      }
    },
    // 设置随机颜色
    getColor(){
      var r = Math.floor(Math.random() * 256);
      var g = Math.floor(Math.random() * 256);
      var b = Math.floor(Math.random() * 256);
      if(r == 255 && g == 255 && b == 255){
          r = 0;
          g = 0;
          b = 0;
      }
      return "rgb("+r+","+g+","+b+")";
    },
    // 跳转登录页
    goLogin() {
      this.$router.push('/personalCenter/login');
    }
  }
};
</script>

<style lang="less" scoped>
.m-screen-pc {
    position: relative;
    width: 100%;
    height: 800px;
    .temp-box {
      position: relative;
      width: 100%;
      // height: 600px;
      min-height: 945px;
    }
    .img {
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
    }
    .login-form {
      position: absolute;
      top: 20%;
      right: 5%;
      padding: 50px 44px;
      width: 465px;
      height: 570px;
    }
    .bg-box {
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      background: #fff;
      opacity: 0.5;
      z-index: 1;
    }
    .real-box {
      position: relative;
      z-index: 2;
    }
    h2 {
      text-align: center;
      font-size: 30px;
      margin-bottom: 12px;
    }
    .usually-box {
      border: 1px solid #fff;
      padding: 6px 14px;
      position: relative;
      margin-bottom: 15px;
      &::after {
        display: block;
        content: "";
        overflow: hidden;
        visibility: hidden;
        clear: both;
      }
      label {
        float: left;
        width: 80px;
        margin-right: 10px;
        font-size: 16px;
        position: relative;
        top: 1px;
      }
      input {
        float: left;
        font: inherit;
        outline: 0;
        border: 0;
        height: 30px;
        width: 235px;
        background: none;
        background-color: rgb(232, 240, 254);
        background-image: none !important;
      }
    }
    .yz-wrap {
      input {
        // background-color: transparent;
        width: 170px;
      }
      #yzm {
        position: absolute;
        top: 0;
        right: 0;
        width: 110px;
        height: 44px;
        background: #fff;
        border: 0;
      }
    }
    .login-btn {
      position: relative;
      margin-top: 32px;
      height: 54px;
      line-height: 54px;
      background: #0078d4;
      color: #fff;
      border-radius: 50px;
      text-align: center;
      img {
        position: absolute;
        top: 10px;
        left: 140px;
      }
      span {
        font-size: 16px;
      }
    }
    .two-password-wrap {
      label {
        width: 100px;
      }
    }
    .yzt-wrap {
      input {
        width: 165px;
        // background-color: transparent;
      }
      .get-yzm {
        position: absolute;
        top: 0;
        right: 0;
        width: 110px;
        height: 44px;
        line-height: 44px;
        background: #0078d4;
        color: #fff;
        text-align: center;
        font-size: 16px;
        cursor: pointer;
      }
    }
    .txt {
      margin-top: 12px;
      display: flex;
      justify-content: space-between;
      a {
        color: #333;
      }
    }
}

.m-screen-mobile {
    position: relative;
    width: 100%;
    height: 10rem;
     .temp-box {
      position: relative;
      width: 100%;
      height: 9rem;
    }
    .img {
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
    }
    .login-form {
      position: relative;
      margin: 0.3rem auto;
      padding: 0.6rem 0.4rem;
      width: 90%;
      height: 95%;
    }
    .bg-box {
      position: absolute;
      top: 10px;
      left: 0;
      width: 100%;
      height: 100%;
      background: #fff;
      opacity: 0.5;
      z-index: 1;
    }
    .real-box {
      position: relative;
      z-index: 2;
    }
    h2 {
      text-align: center;
      font-size: 0.4rem;
      margin-bottom: 0.15rem;
    }
    .usually-box {
      border: 1px solid #fff;
      padding: 0.15rem 0.2rem;
      position: relative;
      margin-bottom: 0.2rem;
      &::after {
        display: block;
        content: "";
        overflow: hidden;
        visibility: hidden;
        clear: both;
      }
      label {
        float: left;
        width: 30%;
        margin-right: 10px;
        font-size: 16px;
        position: relative;
        top: -4px;
      }
      input {
        float: left;
        font: inherit;
        outline: 0;
        border: 0;
        width: 64%;
        background: none;
        background-color: rgb(232, 240, 254);
        background-image: none !important;
        font-size: 16px;
      }
    }
    .two-password-wrap {
      position: relative;
      label {
        width: 45%;
      }
      input { 
        width: 50%;
      }
    }
    .yz-wrap {
      label {
        width: 32%;
      }
      input {
        // background-color: transparent;
        width: 38%;
      }
      #yzm {
        position: absolute;
        top: 0;
        right: 0;
        width: 70px;
        height: 100%;
        background: #fff;
        border: 0;
      }
    }
    .yzt-wrap {
      label {
        width: 19%;
      }
      input {
        width: 40%;
      }
      .get-yzm {
        position: absolute;
        top: 0;
        right: 0;
        width: 90px;
        height: 100%;
        line-height: 2.5;
        background: #0078d4;
        color: #fff;
        text-align: center;
        font-size: 16px;
        cursor: pointer;
      }
    }
    .login-btn {
      position: relative;
      margin-top: 0.1rem;
      height: 1rem;
      line-height: 1rem;
      background: #0078d4;
      color: #fff;
      border-radius: 50px;
      text-align: center;
      img {
        position: absolute;
        top: 0.1rem;
        left: 1.3rem;
      }
      span {
        font-size: 16px;
      }
    }
    .txt {
      margin-top: 12px;
      display: flex;
      justify-content: space-between;
      a {
        color: #333;
      }
    }
}
</style>
